import { z } from 'zod';
import { environment } from './util.environment.js';
import { makeEnvironmentRef } from './util.make-environment-ref.js';

const defaultSchema = z.string();
function asString(key, options) {
  return makeEnvironmentRef(
    () => {
      var _a;
      return ((options == null ? void 0 : options.schema) ?? defaultSchema).parse(
        environment.read(key, {
          optional: (_a = options == null ? void 0 : options.schema) == null ? void 0 : _a.safeParse(void 0).success
        })
      );
    }
  );
}

export { asString };
//# sourceMappingURL=parser.string.js.map
